/**
 * Generated by '@kontent-ai/model-generator@6.5.1'
 */
export const assetFolders = {
    /**
     * Venues
     */
    venues: {
        id: '7b0cbadc-4068-4d51-98f1-0170890eaa85',
        name: 'Venues',
        externalId: undefined,
        folders: {}
    },

    /**
     * Web Banner Assets
     */
    webBannerAssets: {
        id: '9cdf93a4-9bb6-4064-be06-b1c99053f583',
        name: 'Web Banner Assets',
        externalId: undefined,
        folders: {
            /**
             * Terms and conditions
             */
            termsAndConditions: {
                id: 'bb5e0588-2094-48b4-bb00-a7b3ae4de0f7',
                name: 'Terms and conditions',
                externalId: undefined,
                folders: {}
            }
        }
    }
} as const;
